/**
 * New product template: qty +/- and trust guarantee modal.
 */
(function () {
  'use strict';

  function openTrustModal(modal, trigger) {
    if (!modal) return;
    modal._trustFocusBefore = trigger || document.activeElement;
    modal.hidden = false;
    modal.classList.add('is-open');
    document.body.classList.add('new-trust-modal-open');

    var triggers = document.querySelectorAll('[data-trust-modal-open][aria-controls="' + modal.id + '"]');
    triggers.forEach(function (t) {
      t.setAttribute('aria-expanded', 'true');
    });

    window.setTimeout(function () {
      var closeBtn = modal.querySelector('.new-trust-modal__close');
      if (closeBtn) closeBtn.focus();
    }, 10);
  }

  function closeTrustModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
    document.body.classList.remove('new-trust-modal-open');

    var triggers = document.querySelectorAll('[data-trust-modal-open][aria-controls="' + modal.id + '"]');
    triggers.forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });

    var prev = modal._trustFocusBefore;
    if (prev && typeof prev.focus === 'function') {
      prev.focus();
    }
    modal._trustFocusBefore = null;
  }

  function getScrollTop() {
    return (
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }

  /** Ratio of how far the window has scrolled through the scrollable document (0–1). */
  function getDocumentScrollRatio() {
    var docEl = document.documentElement;
    var body = document.body;
    var st = getScrollTop();
    var scrollHeight = Math.max(
      docEl.scrollHeight,
      docEl.offsetHeight,
      body.scrollHeight,
      body.offsetHeight
    );
    var maxScroll = scrollHeight - window.innerHeight;
    if (maxScroll <= 0) return st > 80 ? 1 : 0;
    return st / maxScroll;
  }

  function syncStickyAddToCartBar(productRoot, sticky) {
    if (!sticky) return;

    var mainPrice = productRoot.querySelector('[data-product-price]');
    var stickyPrice = sticky.querySelector('[data-product-price-sticky]');
    if (mainPrice && stickyPrice) {
      stickyPrice.className = mainPrice.className + ' new-product-sticky-cta__price';
      stickyPrice.innerHTML = mainPrice.innerHTML;
    }

    var mainBtn = productRoot.querySelector('form.product-form button[data-cart-submit]');
    var stickyBtn = sticky.querySelector('[data-new-product-sticky-submit]');
    if (!mainBtn || !stickyBtn) return;

    stickyBtn.disabled = mainBtn.disabled;
    stickyBtn.classList.toggle('btn--to-secondary-transitioned', mainBtn.classList.contains('btn--to-secondary-transitioned'));

    ['data-cart-primary-submit-text', 'data-cart-secondary-submit-text'].forEach(function (attrName) {
      var sel = '[' + attrName + ']';
      var ms = mainBtn.querySelector(sel);
      var ss = stickyBtn.querySelector(sel);
      if (!ms || !ss) return;
      ss.innerHTML = ms.innerHTML;
      var ah = ms.getAttribute('aria-hidden');
      if (ah !== null) ss.setAttribute('aria-hidden', ah);
    });
  }

  function initStickyProductCta(productRoot) {
    var sticky = productRoot.querySelector('[data-new-product-sticky]');
    if (!sticky) return;

    if (!sticky._stickyCtaMounted) {
      sticky._stickyCtaMounted = true;
      document.body.appendChild(sticky);
    }

    var pct = parseInt(sticky.getAttribute('data-scroll-threshold'), 10);
    if (isNaN(pct)) pct = 20;
    var threshold = Math.min(100, Math.max(0, pct)) / 100;

    function updateStickyVisibility() {
      var show = getDocumentScrollRatio() >= threshold;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('new-product-sticky-cta-open', show);
    }

    function scheduleSync() {
      window.requestAnimationFrame(function () {
        syncStickyAddToCartBar(productRoot, sticky);
      });
    }

    var form = productRoot.querySelector('form.product-form');
    if (form) {
      form.addEventListener('change', scheduleSync);
      form.addEventListener('input', scheduleSync);
    }

    var mainBtn = productRoot.querySelector('form.product-form button[data-cart-submit]');
    var stickyBtn = sticky.querySelector('[data-new-product-sticky-submit]');
    if (mainBtn && stickyBtn && !stickyBtn._wiredStickySubmit) {
      stickyBtn._wiredStickySubmit = true;
      stickyBtn.addEventListener('click', function () {
        var anchor = productRoot.querySelector('[data-product-main-form]');
        var reduceMotion =
          window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (anchor && typeof anchor.scrollIntoView === 'function') {
          anchor.scrollIntoView({
            behavior: reduceMotion ? 'auto' : 'smooth',
            block: 'start'
          });
        }

        /* Sticky CTA: scroll only — do not add to cart (re-enable below to submit main form after scroll).
        var delay = reduceMotion ? 120 : 520;
        window.setTimeout(function () {
          var productForm = productRoot.querySelector('form.product-form');
          var submitBtn = productForm ? productForm.querySelector('button[data-cart-submit]') : null;
          if (!submitBtn || submitBtn.disabled) return;
          if (typeof productForm.requestSubmit === 'function') {
            try {
              productForm.requestSubmit(submitBtn);
              return;
            } catch (err) {
            }
          }
          submitBtn.click();
        }, delay);
        */
      });

      if (typeof MutationObserver !== 'undefined') {
        var obs = new MutationObserver(scheduleSync);
        obs.observe(mainBtn, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ['disabled', 'class']
        });
      }
    }

    scheduleSync();
    window.addEventListener('scroll', updateStickyVisibility, { passive: true });
    window.addEventListener('resize', updateStickyVisibility, { passive: true });
    updateStickyVisibility();
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openModalEl = document.querySelector('.new-trust-modal.is-open[data-trust-modal]');
    if (openModalEl) closeTrustModal(openModalEl);
  });

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-trust-modal-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var id = trigger.getAttribute('aria-controls');
        var modal = id ? document.getElementById(id) : null;
        openTrustModal(modal, trigger);
      });
    });

    document.querySelectorAll('[data-trust-modal]').forEach(function (modal) {
      modal.querySelectorAll('[data-trust-modal-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          closeTrustModal(modal);
        });
      });
    });

    document.querySelectorAll('.product-template.new-product-template').forEach(initStickyProductCta);

    document.querySelectorAll('.new-product-template [data-new-qty-pill]').forEach(function (wrap) {
      var input = wrap.querySelector('.product-form__quantity-input');
      var dec = wrap.querySelector('[data-new-qty-dec]');
      var inc = wrap.querySelector('[data-new-qty-inc]');
      if (!input || !dec || !inc) return;

      function clampQty(n) {
        var v = parseInt(String(n), 10);
        if (isNaN(v) || v < 1) v = 1;
        return v;
      }

      function setQty(next) {
        input.value = String(clampQty(next));
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      dec.addEventListener('click', function () {
        setQty(clampQty(input.value) - 1);
      });

      inc.addEventListener('click', function () {
        setQty(clampQty(input.value) + 1);
      });
    });
  });
})();
